export default __webpack_public_path__ + "static/media/ar.b66df6ae.jpeg";